import React from "react";
import { bool, shape, string } from "prop-types";
import * as configUtils from "util/config";
import * as i18n from "util/i18n";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import GridTable from "pages/_components/GridTable/GridTable";

const SignaturesSchemeItem = ({ isDesktop, signatureScheme, administrationScheme, type }) => {
    const getSigners = () => {
        const { groupsMap } = signatureScheme;

        return administrationScheme === "medium"
            ? groupsMap.A
            : Object.keys(groupsMap).reduce((result, key) => result + key.toString().repeat(groupsMap[key]), "");
    };

    const textFunctionalGroups = (functionalGroups) => {
        let text = functionalGroups
            .slice(0, 2)
            .map((functionalGroup) => i18n.get(`administration.signatures.functionalGroups.${functionalGroup}`))
            .join(", ");
        if (functionalGroups.length > 2) {
            text += ` (+${functionalGroups.length - 2})`;
        }
        return text;
    };

    const itemDesktop = () => (
        <>
            <GridTable.Data
                columnStart={1}
                columnWidth={1}
                rowStart={1}
                rowWidth={1}
                alignX={isDesktop ? "center" : "flex-start"}
                alignY="center">
                <span className="data-aux">{getSigners()}</span>
            </GridTable.Data>
            {(administrationScheme === "advanced" || administrationScheme === "medium") && (
                <GridTable.Data
                    columnStart={2}
                    columnWidth={isDesktop ? 1 : 2}
                    rowStart={1}
                    rowWidth={1}
                    alignX={isDesktop ? "center" : "flex-start"}
                    alignY="center">
                    <span className="data-aux">{i18n.get(`signatures.type.${signatureScheme.signatureType}`)}</span>
                </GridTable.Data>
            )}
            {(administrationScheme === "advanced" || administrationScheme === "medium") &&
            signatureScheme.functionalGroups &&
            signatureScheme.functionalGroups.length ? (
                <GridTable.Data
                    columnStart={isDesktop ? 3 : 1}
                    columnWidth={isDesktop ? 1 : 2}
                    rowStart={isDesktop ? 1 : 2}
                    rowWidth={1}
                    alignX={isDesktop ? "center" : "flex-start"}
                    alignY="center">
                    <span className="data-aux">{textFunctionalGroups(signatureScheme.functionalGroups)}</span>
                </GridTable.Data>
            ) : (
                <GridTable.Data
                    columnStart={isDesktop ? 3 : 1}
                    columnWidth={isDesktop ? 1 : 2}
                    rowStart={isDesktop ? 1 : 2}
                    rowWidth={1}
                    alignX={isDesktop ? "center" : "flex-start"}
                    alignY="center">
                    <span className="data-aux">-</span>
                </GridTable.Data>
            )}
            {administrationScheme === "advanced" &&
            signatureScheme.signatureType === "AMOUNT" &&
            signatureScheme.capList.length > 0 ? (
                <GridTable.Data
                    columnStart={4}
                    columnWidth={1}
                    rowStart={1}
                    rowWidth={2}
                    alignX="center"
                    alignY="center"
                    flexDirection="row">
                    <FormattedAmount
                        className="data-amount"
                        frequencyInSpan
                        currency={configUtils.get("core.masterCurrency")}
                        quantity={
                            signatureScheme.capList[0].maximum === -1
                                ? configUtils.get(`default_cap_signature_${type}`)
                                : signatureScheme.capList[0].maximum
                        }
                        frequency={i18n.get("administration.signatures.create.advanced.topAmountPerPeriod", null, {
                            period: i18n.get(
                                `administration.signatures.transactions.capFrequency.${signatureScheme.capList[0].frequency}`,
                            ),
                        })}
                    />
                </GridTable.Data>
            ) : (
                <GridTable.Data
                    columnStart={4}
                    columnWidth={1}
                    rowStart={1}
                    rowWidth={1}
                    alignX="center"
                    alignY="center"
                    flexDirection="row">
                    <span className="data-aux">-</span>
                </GridTable.Data>
            )}
        </>
    );

    const itemMobile = () => (
        <GridTable.Container rows={4} columns={3} renderAs="div">
            <GridTable.Data rowStart={1} columnStart={1} alignY="flex-start">
                <CustomData
                    dataClass="custom-data-title"
                    titleText="administration.signatures.list.signers"
                    titleTextType="I18N"
                />
            </GridTable.Data>
            <GridTable.Data rowStart={1} columnStart={3} alignY="flex-end">
                <span className="data-aux">{getSigners()}</span>
            </GridTable.Data>
            {(administrationScheme === "advanced" || administrationScheme === "medium") && (
                <>
                    <GridTable.Data rowStart={2} columnStart={1} alignY="flex-start">
                        <CustomData
                            dataClass="custom-data-title"
                            titleText="administration.signatures.list.transactions"
                            titleTextType="I18N"
                        />
                    </GridTable.Data>
                    <GridTable.Data rowStart={2} columnStart={3} alignY="flex-start">
                        {/* <span className="data-aux">{i18n.get(`signatures.type.${signatureScheme.signatureType}`)}</span> */}
                        {signatureScheme.capList && signatureScheme.capList.length > 0 ? (
                            <span className="data-aux">Con importe</span>
                        ) : (
                            <span className="data-aux">Sin importe</span>
                        )}
                    </GridTable.Data>
                    <GridTable.Data rowStart={3} columnStart={1} alignY="flex-start">
                        <CustomData
                            dataClass="custom-data-title"
                            titleText="administration.signatures.list.functionalGroups"
                            titleTextType="I18N"
                        />
                    </GridTable.Data>
                    <GridTable.Data rowStart={3} columnStart={3} alignY="flex-start">
                        {(administrationScheme === "advanced" || administrationScheme === "medium") &&
                        signatureScheme.functionalGroups &&
                        signatureScheme.functionalGroups.length ? (
                            <span className="data-aux">{textFunctionalGroups(signatureScheme.functionalGroups)}</span>
                        ) : (
                            <span className="data-aux">-</span>
                        )}
                    </GridTable.Data>
                </>
            )}
            <GridTable.Data rowStart={4} columnStart={1} alignY="flex-start">
                <CustomData
                    dataClass="custom-data-title"
                    titleText="administration.signatures.list.amountPerPeriod"
                    titleTextType="I18N"
                />
            </GridTable.Data>
            <GridTable.Data rowStart={4} columnStart={3} alignY="flex-start">
                {administrationScheme === "advanced" &&
                signatureScheme.signatureType === "AMOUNT" &&
                signatureScheme.capList.length > 0 ? (
                    <FormattedAmount
                        className="data-amount"
                        frequencyInSpan
                        currency={configUtils.get("core.masterCurrency")}
                        quantity={
                            signatureScheme.capList[0].maximum === -1
                                ? configUtils.get(`default_cap_signature_${type}`)
                                : signatureScheme.capList[0].maximum
                        }
                        frequency={i18n.get("administration.signatures.create.advanced.topAmountPerPeriod", null, {
                            period: i18n.get(
                                `administration.signatures.transactions.capFrequency.${signatureScheme.capList[0].frequency}`,
                            ),
                        })}
                    />
                ) : (
                    <span className="data-aux">-</span>
                )}
            </GridTable.Data>
        </GridTable.Container>
    );

    return isDesktop ? itemDesktop() : itemMobile();
};

SignaturesSchemeItem.propTypes = {
    isDesktop: bool.isRequired,
    signatureScheme: shape({}).isRequired,
    administrationScheme: string.isRequired,
    type: string.isRequired,
};

export default SignaturesSchemeItem;
